import AbstractObserver from './abstract';

export default class HeaderMomentShowHideObserver extends AbstractObserver {
  constructor(element) {
    super(element);
    this.dataSettings = this.element.hasAttribute('data-ua-header-options')
      ? JSON.parse(this.element.getAttribute('data-ua-header-options'))
      : {};
  }

  init() {
    this.direction = 'down';
    this.delta = 0;
    this.defaultState = true;

    this.offset =
      isFinite(this.dataSettings.fixMoment) && this.dataSettings.fixMoment !== 0 ? this.dataSettings.fixMoment : 5;
    this.effect = this.dataSettings.fixEffect ? this.dataSettings.fixEffect : 'show-hide';

    return this;
  }

  destroy() {
    this.toDefaultState();

    return this;
  }

  checkDirection() {
    if (window.scrollY > this.delta) {
      this.direction = 'down';
    } else {
      this.direction = 'up';
    }

    this.delta = window.scrollY;

    return this;
  }

  toDefaultState() {
    this.toggleEffectClass('remove');
    this.defaultState = !this.defaultState;

    return this;
  }

  changeState() {
    this.toggleEffectClass('add');
    this.defaultState = !this.defaultState;

    return this;
  }

  toggleEffectClass(action) {
    const effectClasses = {
      slide: 'navbar-moved-up',
      fade: 'navbar-faded',
      'show-hide': 'navbar-invisible',
    };

    this.element.classList[action](effectClasses[this.effect]);
  }

  check() {
    let docScrolled = window.scrollY;

    this.checkDirection();

    if (docScrolled >= this.offset && this.defaultState && this.direction === 'down') {
      this.changeState();
    } else if (!this.defaultState && this.direction === 'up') {
      this.toDefaultState();
    }

    return this;
  }
}
